import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

export class LocalFaturamentoFilter implements Filter {
    nome: string;
    situacao: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Nome
        if (this.nome) {
            params = params.append('nome', this.nome);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        return params;
    }

    clear() {
        this.nome = null;
        this.situacao = null;
    }
}
